import React from "react";

import { HubHookFormSelect } from "../HubHookFormSelect";
import { PRIORITY_TYPES } from "../../constants/priority";
import { PriorityLabel } from "../PriorityLabel";

export const HubPrioritySelect = ({ name = "", defaultValue = 2, ...rest }) => {
  return (
    <HubHookFormSelect
      name={name}
      defaultValue={defaultValue}
      required
      placeholder="Priority"
      options={PRIORITY_TYPES}
      RenderComponent={PriorityLabel}
      renderValue={(value) => {
        const priority = PRIORITY_TYPES?.find(({ id }) => id === value);
        return <PriorityLabel {...priority} />;
      }}
      {...rest}
    />
  );
};

export default HubPrioritySelect;
